import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// ✅ Helper for request body
const injectSubTenantDTO = (data) => {
  const jsonData = typeof data === "string" ? JSON.parse(data) : data;
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    jsonData.subTenantDTO = { id: decodedToken.subTenantId };
  }
  return JSON.stringify(jsonData);
};

// ✅ Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (
    decodedToken?.roles?.includes("TENANT_ADMIN") ||
    decodedToken?.subTenantId === undefined
  ) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const StorageInstructionsApi = {
  // ✅ Create StorageInstructions API
  CreateStorageInstructions: (data) => {
    data = injectSubTenantDTO(data);
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/storage-instructions`, data, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },

  // ✅ Update StorageInstructions API
  PutStorageInstructions: (storageID, data) => {
    data = injectSubTenantDTO(data);
    return new Promise((resolve, reject) => {
      apiApp
        .put(`/storage-instructions/${storageID}`, data, { headers: getHeaders() })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },

  // ✅ Get Single StorageInstructions API
  SingleStorageInstructions: (storageID) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/storage-instructions/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers: getHeaders() }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },

  // ✅ List StorageInstructions API
  ListStorageInstructions: (page, limit) => {
    return new Promise((resolve, reject) => {
      apiApp
        .get(
          `/storage-instructions?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers: getHeaders() }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },

  // ✅ Delete StorageInstructions API
  DeleteStorageInstructions: (storageID) => {
    return new Promise((resolve, reject) => {
      apiApp
        .delete(
          `/storage-instructions/${storageID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
          { headers: getHeaders() }
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error?.response?.data));
    });
  },
};

export default StorageInstructionsApi;
